module.exports = __webpack_public_path__ + "src/assets/images/warning-icon.eb01e38a8a695c376f9a31219130d5b9.svg";